module.exports = __webpack_public_path__ + "static/media/referral.ae9d2f60.png";